<template>
  <img v-if="props.circleId != null && Boolean(props.hasImg)" :src="imgUrl" :alt="props.circleName">
  <img v-else-if="props.circleId != null && !Boolean(props.hasImg)" :src="nonCircleIcon" :alt="props.circleName">
</template>
<script setup>
import Common from '../../js/common.js'
import Global from '../../js/constant.js'
import { computed, defineProps } from 'vue';

const props = defineProps({
  hasImg : {
    type : Boolean,
    required: true
  },
  circleId : {
    type : Number,
    required : false
  },
  circleName : {
    type : String,
    required : false
  },  
})
const imgUrl = computed(() => '/app/images/circle/' + props.circleId)
const nonCircleIcon = computed(() => Common.getBaseUrl() + Global.static_path + '/images/common/circle_icon.png')
</script>